export default __webpack_public_path__ + "static/media/image.cipher-labz-pvt-ltd-.6275534e.png";